import dayjs from "dayjs";
const Columns = () => {

	let col = [
		{
			id: 'unot',
			name: 'Unidad',
			selector: row => `${row.unit}`,
			sortable: true,
			minWidth:'100px'
		},
		{
			id: 'datetime',
			name: 'Hora llegada',
			selector: row => `${(row?.time ?? '-') != '-' ? dayjs(row.time).format('HH:mm'): '-'}`,
			sortable: true,
			minWidth:'100px'
		},
	]	

	let columns = col
	return columns;
}

export default Columns;